import { SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select/types';
import Vue from 'vue';
import { RouteConfig } from 'vue-router/types/router';
import { CardPaymentForm, EcheckPaymentForm, ImageConfigs, Step } from '../types/types';
import CheckOutPage from './../msw-checkout.vue';
const wizardSteps: Step[] = [{
  stepLabel: '1',
  stepTitle: 'Billing',
  stepState: 'default',
}, {
  stepLabel: '2',
  stepTitle: 'Payment',
  stepState: 'default',
}, {
  stepLabel: '3',
  stepTitle: 'Confirmation',
  stepState: 'default',
}];

const initialAddressInfo = {
  fullName : '',
  company  : '',
  emailAddress : '',
  phone : '',
  address1 : '',
  address2  : '',
  city : '',
  country  : '',
  state : '',
  province : '',
  zipcode : '',
  isDisable: false,
  vatNumber: '',
  gstNumber: '',
};

const DEFAULT_TEXTFIELD_WIDTH = '29rem';

const initialCardPaymentForm : CardPaymentForm = {
  cardNumber: '',
  month: '',
  year:'',
  cvv:'',
  isDisable: false,
  paymentType: 'card',
  selectedCardType: '',
};

const initialEcheckPaymentForm: EcheckPaymentForm = {
  bankName : '',
  eCheckSelectedAcType : '',
  nameOnAc : '',
  dlState : '',
  dlNumber: '',
  acNumber: '',
  routingNo: '',
  paymentType: 'echeck',
};

const months: SelectOption[] = [
  { value: '01', label: 'January', id:'01'  },
  { value: '02', label: 'February', id:'02' },
  { value: '03', label: 'March', id:'03' },
  { value: '04', label: 'April', id:'04' },
  { value: '05', label: 'May', id:'05' },
  { value: '06', label: 'June', id:'06' },
  { value: '07', label: 'July', id:'07' },
  { value: '08', label: 'August', id:'08' },
  { value: '09', label: 'September', id:'09' },
  { value: '10', label: 'October', id:'10' },
  { value: '11', label: 'November', id:'11' },
  { value: '12', label: 'December', id:'12' }];

const imageMappings: { [id: string] : ImageConfigs; } = {
  visa : { path : require('@/assets/images/visa.png'), name:'visa' },
  mastercard : { path: require('@/assets/images/mastercard.png'), name:'mastercard' },
  discover : { path:require('@/assets/images/discover.png'), name:'discover' },
  amex : { path: require('@/assets/images/amex.png'), name:'amex' },
  confirm_order: { path: require('@/assets/images/order_confirmed.png'), name: 'confirm_order' },
};

const eCheckAcTypes = [
  { id: 'C', label: 'Checking', value: 'C' },
  { id: 'S', label: 'Savings', value: 'S' },
];

const initialCompleteOrderRequest = {
  bankName: '',
  accType: '',
  routingNumber: '',
  enccardetails: '',
  isPOOrder:true,
  accNumber: '',
  accName: '',
  drivingLic: '',
  drivingLicenseState: '',
  paymentMode: '',
  customerAddressId: '',
  payTokenId: '',
  cardtype: '',
  ccnumber: '',
  ccexpdate: '',
  cvv: '',
};

const childrenRoutes: RouteConfig[] = [{
  path: 'billing',
  component: CheckOutPage,
}, {
  path: 'payment',
  component: CheckOutPage,
}, {
  path: 'confirmation',
  component: CheckOutPage,
}, {
  path: 'order_details',
  component: CheckOutPage,
}];

export {
  wizardSteps,
  initialAddressInfo,
  DEFAULT_TEXTFIELD_WIDTH,
  initialCardPaymentForm,
  initialEcheckPaymentForm,
  months,
  imageMappings,
  eCheckAcTypes,
  initialCompleteOrderRequest,
  childrenRoutes,
};

export const updateCartCountEventBus = new Vue();
export const UPDATE_CART_COUNT = 'update-cart';
